import React, { useState, useEffect } from 'react';

export default function EditPlanModal({ open, plan, onClose, onSave }:{ open:boolean, plan:any, onClose:()=>void, onSave:(p:any)=>void }){
  const [draft, setDraft] = useState<any>(plan || {});
  useEffect(()=>{ setDraft(plan || { isActive: true, features: [] }); }, [plan]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl p-4">
        <h3 className="text-lg font-semibold mb-2">Edit Plan</h3>
        <div className="space-y-2">
          <input value={draft.name||''} onChange={e=>setDraft({...draft, name: e.target.value})} className="w-full p-2 border rounded" placeholder="Name" />
          <input value={draft.price||''} onChange={e=>setDraft({...draft, price: e.target.value})} className="w-full p-2 border rounded" placeholder="Price" />
          <textarea value={draft.description||''} onChange={e=>setDraft({...draft, description: e.target.value})} className="w-full p-2 border rounded" placeholder="Description" />
          <input value={(draft.features||[]).join(', ')} onChange={e=>setDraft({...draft, features: e.target.value.split(',').map((s:string)=>s.trim())})} className="w-full p-2 border rounded" placeholder="Features (comma separated)" />

          <div className="flex items-center gap-2 mt-2">
            <label className="inline-flex items-center gap-2"><input type="checkbox" checked={!!draft.isActive} onChange={e=>setDraft({...draft, isActive: e.target.checked})} /> Active</label>
            <span className="text-xs text-gray-500">Reorder plans by editing or re-saving to change preview order</span>
          </div>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1 border rounded">Cancel</button>
          <button onClick={()=>{ // normalize price
            if (draft.price) {
              const parsed = parseFloat(String(draft.price).replace(/[^0-9.]/g, '')) || 0;
              draft.price = parsed;
            }
            onSave(draft); onClose();
          }} className="px-3 py-1 bg-blue-600 text-white rounded">Save</button>
        </div>
      </div>
    </div>
  );
}
